export const website = {
  rootUrl: "https://podroomcreative.com"
}